import React from "react";

const CenteredMessage = ({ heading, message }) => {
    return (
        <div style={styles.container}>
            <h1 style={styles.heading}>{heading}</h1>
            <p style={styles.message}>{message}</p>
        </div>
    );
};

// Inline styles for the component
const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        backgroundColor: "#f8f9fa", // Light gray background
        padding: "20px",
    },
    heading: {
        fontSize: "2.5rem",
        color: "#333", // Dark gray text
        marginBottom: "16px",
    },
    message: {
        fontSize: "1.25rem",
        color: "#666", // Medium gray text
    },
};

export default CenteredMessage;